import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ApplicantOptionalField } from '@app/models/recruiting/applicant-optional-field.model';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { JobPostingOptionalField } from '@app/modules/applicant-tracker/interfaces/optional-field.interface';
import { JobPostingOptionalFieldMap } from '@app/modules/applicant-tracker/meta/applicant-optional-fields';
import { ApplicantOptionalFieldService } from '@app/modules/applicant-tracker/services';
@Component({
    selector: 'app-required-fields-card',
    templateUrl: './required-fields-card.component.html',
    styleUrls: ['./required-fields-card.component.scss'],
})
export class RequiredFieldsCardComponent implements OnInit {
    @Input() jobPosting: JobPosting;
    @Output() onSelect = new EventEmitter<JobPostingOptionalField[]>();

    fields: JobPostingOptionalField[] = [
        {
            label: 'applicant-tracker.components.required-fields-card.nameRequired',
            summaryLabel: 'applicant-tracker.components.required-fields-card.name',
            name: 'name',
            disabled: true,
            checked: true,
        },
        {
            label: 'applicant-tracker.components.required-fields-card.emailRequired',
            summaryLabel: 'applicant-tracker.components.required-fields-card.email',
            name: 'email',
            disabled: true,
            checked: true,
        },
        {
            label: 'applicant-tracker.components.required-fields-card.phoneRequired',
            summaryLabel: 'applicant-tracker.components.required-fields-card.phone',
            name: 'phone',
            disabled: false,
            checked: true,
            typeId: JobPostingOptionalFieldMap.phone,
        },
        {
            label: 'applicant-tracker.components.required-fields-card.countryRequired',
            summaryLabel: 'applicant-tracker.components.required-fields-card.country',
            name: 'country',
            disabled: false,
            checked: true,
            typeId: JobPostingOptionalFieldMap.country,
        },
        {
            label: 'applicant-tracker.components.required-fields-card.postalCodeRequired',
            summaryLabel: 'applicant-tracker.components.required-fields-card.postalCode',
            name: 'postal_code',
            disabled: false,
            checked: true,
            typeId: JobPostingOptionalFieldMap.postal_code,
        },
    ];

    requiredLabel = ' (Required)';

    constructor(private applicantOptionalFieldService: ApplicantOptionalFieldService) {}

    ngOnInit(): void {
        this.initialize();
    }

    /**
     * Has to be called by ngOnInit, every time the section is loaded and after save draft
     */
    initialize(): void {
        if (this.jobPosting?.applicantOptionalFields.length) {
            this.loadApplicantOptionalFields();

            // Clear all applicantOptionalFields since applicantOptionalFieldService checks that property to attach items.
            if (!this.jobPosting?.draftAt && !this.jobPosting.isPersisted) {
                this.jobPosting.applicantOptionalFields = [];
            }
        }

        // Add to service so that we can use it in the summary page of the job posting create.
        this.applicantOptionalFieldService.fields = this.fields;

        this.applicantOptionalFieldService.attachAndDetachToJobPosting(this.jobPosting, this.fields);
    }

    loadApplicantOptionalFields(): void {
        this.fields.forEach((field: JobPostingOptionalField) => {
            const exists = this.jobPosting.applicantOptionalFields.some((applicantField: ApplicantOptionalField) => {
                return applicantField.fieldName === field.name;
            });

            if (exists) {
                field.checked = false;
                field.label = field.label.toString().replace('Required', '');
                return;
            }

            if (field.name !== 'name' && field.name !== 'email') {
                field.checked = true;
            }
        });
    }

    onCheck(option: MatCheckboxChange, field: JobPostingOptionalField): void {
        field.checked = option.checked;

        if (field.checked) {
            field.label = field.label + 'Required';
        } else {
            field.label = field.label.toString().replace('Required', '');
        }

        // Add to service so that we can use it in the summary page of the job posting create.
        this.applicantOptionalFieldService.fields = this.fields;
        this.onSelect.emit(this.fields);
    }
}
